<template>
  <div class="tv-addons">
    <base-heading :underline="false" class="addon-heading">{{ $t('overviewAddons.addonsTitle') }}</base-heading>
    <base-table :data="$props.serviceInfo.activatedAddons"
                :columns="columnDefinition"
                class="addons-table">
      <template #status="data">
        <p class="tv-status" v-if="isTvSubscriptionType">
          {{ data.rowData.recurring ? $t('overviewAddons.recurringTrueTitle') : $t('overviewAddons.recurringFalseTitle') }}
        </p>
        <p v-else class="expiration-date">
          {{ `${$t('overviewAddons.expiresLabel')} - ${data.rowData.expirationDate}` }}
        </p>
      </template>
      <template #channelList="data">
        <base-button v-if="data.rowData.code"
                     variant="text"
                     class="channels-button"
                     @click="emitViewChannels(data)">
          {{ $t('overviewAddons.channelListButton') }}
        </base-button>
        <div v-else class="no-code"></div>
      </template>
    </base-table>

    <modal :visible="channelListVisible"
           size="md"
           class="addons-channel-modal"
           @modal-close="channelListVisible = false">
      <base-inline-loader v-if="dataLoading"/>
      <television-channel-list v-else
                               :channel-data="channelData"
                               :package-name="selectedPackageName"
                               :show-channel-count="false"
                               :total-channels="channelTotalCount"/>
    </modal>
  </div>
</template>

<script>
import BaseTable from '@/components/base/table/base-table'
import Modal from '@/components/common/modal/modal'
import { tvColumns, mobileColumns } from '@/components/services/other/addons-config'
import { makeQueryString } from '@/utils/queryParser'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import TelevisionChannelList from '@/components/services/resources/television-channel-list'

export default {
  name: 'addon-table',
  data () {
    return {
      channelListVisible: false,
      dataLoading: false,
      channelData: [],
      selectedPackageName: '',
      channelTotalCount: null
    }
  },
  components: { TelevisionChannelList, Modal, BaseTable },
  mixins: [errorMessageHandler],
  props: {
    serviceInfo: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    }
  },
  computed: {
    columnDefinition () {
      if (this.$props.serviceInfo.subscriptionType === 'TELEVISION') return Object.freeze(tvColumns)
      return Object.freeze(mobileColumns)
    },
    isTvSubscriptionType () {
      return this.$props.serviceInfo.subscriptionType === 'TELEVISION'
    }
  },
  methods: {
    emitViewChannels (data) {
      this.dataLoading = true
      this.channelListVisible = true
      this.selectedPackageName = data.rowData.name
      this.getChannels(true, data.rowData.code)
    },
    getChannels (forceFetch = false, addonName) {
      const { tvPackageCode, subscriberIdentity } = this.$props.serviceInfo
      const qs = makeQueryString({ packageCode: addonName || tvPackageCode, subscriberIdentity: subscriberIdentity })
      if (!this.channelData.length || forceFetch) {
        this.$apiRequest.get(`user/service/tvchannels${qs}`)
          .then(response => {
            this.channelData = response.data.categories || []
            if (this.channelData.length) {
              this.channelTotalCount = this.channelData[0].totalProductCount || null
            }
          })
          .catch(e => {
            this.handleErrorMessage(e.response.data)
          })
          .finally(() => {
            this.dataLoading = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tv-addons {
  padding: 0 2rem 2rem 2rem;

  @media (map_get($breakpoints, lg)) {
    padding-top: 2rem;
    padding-right: 0;
  }

  .expiration-date {
    margin-bottom: 0;
    white-space: nowrap;
  }
}
</style>
